<script setup>
import {useAuthenticationStore} from '@/stores'
import {clearImpersonationUserToken} from '@shared-utils/auth/impersonation/helpers'

const {user} = useAuthenticationStore()
const endImpersonationAndClose = async () => {
  clearImpersonationUserToken()
  window.close()
}
</script>

<template>
  <div class="impersonation-alert alert alert-warning custom fs-4">
    <span>
      You are acting as <span class="fw-semibold">{{ user?.name || user?.email }}</span>
      <span v-if="user?.company?.title">
        in <span class="fw-semibold">{{ user?.company?.title }}</span></span
      >
    </span>

    <span @click="endImpersonationAndClose()" class="custom px-3 mb-2 pointer">
      <img src="../../../../../packages/shared/src/assets/images/icons/ui/exit-log-out-purple.svg" alt="exit" />
    </span>
  </div>
</template>

<style lang="scss">
.impersonation-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 0;
  border: 0;
  padding: 4px 0;
}
</style>
